import { NgClass } from '@angular/common';
import { Component, input } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { UiText } from '@ory/client';

/** Kratos's messages for a flow, translated by id (`kratosMessages.<id>`). */
@Component({
  selector: 'app-kratos-messages',
  templateUrl: './kratos-messages.component.html',
  imports: [NgClass, TranslocoModule],
  host: { class: 'block' },
})
export class KratosMessagesComponent {
  readonly messages = input.required<UiText[]>();
}
